import React from 'react';
import styles from '../irlObservations2026.module.css';
import { DetailHeader, DetailTabs, IrlCounts, stripHtmlText } from './shared';

export default function IRL_Related({ request, tab, onTab, onBack, onOpenAi, onCopy, copied, tabs, onRelatedObs, extraActions, onUpdateFields, busy }) {
    return (
        <>
            <DetailHeader kind="irl" item={request} onBack={onBack} onOpenAi={onOpenAi} onCopy={onCopy} copied={copied} extraActions={extraActions} onUpdateFields={onUpdateFields} busy={busy} />
            <DetailTabs tabs={tabs} tab={tab} onTab={onTab} counts={IrlCounts(request)} />
            <div className={styles.detailBody}>
                <div className={styles.detailInner}>
                    <div className={styles.sectionLabelSm}>Linked Observations</div>
                    {(request.linkedObservations || []).length === 0 && <p className={styles.emptyBody}>No linked observations.</p>}
                    {(request.linkedObservations || []).map(item => (
                        <button key={item.id} type="button" className={styles.relatedCard} onClick={() => onRelatedObs?.(item.id)}>
                            <span>
                                <span className={styles.rowId}>{item.id}</span>
                                <span className={styles.rowTitle}>{stripHtmlText(item.title)}</span>
                            </span>
                        </button>
                    ))}
                </div>
            </div>
        </>
    );
}
